import { render, staticRenderFns } from "./jobCard.vue?vue&type=template&id=af60d446&scoped=true"
import script from "./jobCard.vue?vue&type=script&lang=js"
export * from "./jobCard.vue?vue&type=script&lang=js"
import style0 from "./jobCard.vue?vue&type=style&index=0&id=af60d446&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af60d446",
  null
  
)

export default component.exports